import { memo } from "react";

const AppRecipientEmailIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_8205_4696)">
				<path
					d="M1.99 4.64C0.9 4.64 0 5.54 0 6.63V16.62C0 17.71 0.9 18.61 1.99 18.61H16.58C17.67 18.61 18.57 17.71 18.57 16.62V6.63C18.57 6.28 18.62 5.93 18.48 5.5C18.41 5.28 18.27 5.03 18.03 4.87C17.79 4.71 17.51 4.65 17.24 4.65H14.59C14.22 4.65 13.93 4.95 13.93 5.31C13.93 5.67 14.23 5.97 14.59 5.97H17.22C14.86 8.04 12.43 10.09 10.03 12.14C9.56 12.56 9.01 12.56 8.54 12.14L1.54 5.97C2.35 5.97 3.18 5.97 3.98 5.97C4.35 5.97 4.64 5.67 4.64 5.31C4.64 4.95 4.34 4.65 3.98 4.65H1.99V4.64ZM1.33 7.55L7.66 13.13C8.59 13.95 9.98 13.95 10.91 13.13L17.24 7.71V16.61C17.24 16.99 16.96 17.27 16.58 17.27H1.99C1.61 17.27 1.33 16.99 1.33 16.61V7.55Z"
					fill={color}
				/>
				<path
					d="M9.27927 0C8.90927 0 8.61927 0.3 8.61927 0.66V6.47L7.10927 4.87C6.79927 4.55 6.45927 4.61 6.16927 4.84C5.89927 5.09 5.88927 5.51 6.13927 5.78L8.78927 8.6C9.04927 8.88 9.48927 8.88 9.75927 8.6L12.4093 5.78C12.6593 5.51 12.6493 5.09 12.3793 4.84C12.1093 4.59 11.6893 4.6 11.4393 4.87L9.92927 6.47V0.66C9.92927 0.29 9.62927 0 9.26927 0H9.27927Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_8205_4696">
					<rect width="18.57" height="18.61" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default memo(AppRecipientEmailIcon);
